import React from 'react';
import '../App.css';

export default function Valuations() {
    return <h1 className='valuations'>VALUATIONS</h1>;
}